import { render, staticRenderFns } from "./TheFilterMainTyreMoto.vue?vue&type=template&id=67913923&"
import script from "./TheFilterMainTyreMoto.vue?vue&type=script&lang=js&"
export * from "./TheFilterMainTyreMoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports